window.PageContent = (function () {
    return {
        init: function () {
            if (globalAppSettings.isMobileDevice) {
                return;
            }

            this.scrollbar = new AwesomeScrollbar('#page-content__scrollbar-container', 'm-page-content-scrollbar');
            this.rightColScrollbar = new AwesomeScrollbar('#app-body__right-col-scroll-area', 'app-body__right-col-scrollbar-area-wrapper');
        }
    };
}());